export const ADD_ITEM_OP = "add";
export const REMOVE_ITEM_OP = "remove";

export const confirmOpIsValid = op =>
  op === ADD_ITEM_OP || op === REMOVE_ITEM_OP;
